module.exports = __webpack_public_path__ + "img/category-cardigans.2ff474e2.jpg";